import React from 'react'

const ProgressGraphic = ({percentage, fillColor}) => (
    <div>
    <svg
      preserveAspectRatio='none'
      viewBox='0 0 1260 193'
    >
      <rect y='182.5' width='50' height='10' fill={fillColor} />
      <rect
        x='62'
        y='173.5'
        width='50'
        height='19'
        fill={percentage > 9 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='125'
        y='165.5'
        width='50'
        height='27'
        fill={percentage > 14 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='189'
        y='156.5'
        width='50'
        height='36'
        fill={percentage > 19 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='252'
        y='148.5'
        width='50'
        height='44'
        fill={percentage > 24 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='316'
        y='139.5'
        width='50'
        height='53'
        fill={percentage > 29 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='380'
        y='130.5'
        width='50'
        height='62'
        fill={percentage > 34 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='443'
        y='121.5'
        width='50'
        height='71'
        fill={percentage > 39 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='508'
        y='112.5'
        width='50'
        height='80'
        fill={percentage > 44 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='572'
        y='104.5'
        width='50'
        height='88'
        fill={percentage > 49 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='635'
        y='95.5'
        width='50'
        height='97'
        fill={percentage > 54 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='699'
        y='86.5'
        width='50'
        height='106'
        fill={percentage > 59 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='762'
        y='77.5'
        width='50'
        height='115'
        fill={percentage > 64 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='825'
        y='69.5'
        width='50'
        height='123'
        fill={percentage > 69 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='888'
        y='60.5'
        width='50'
        height='132'
        fill={percentage > 74 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='952'
        y='51.5'
        width='50'
        height='141'
        fill={percentage > 79 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='1015'
        y='42.5'
        width='50'
        height='150'
        fill={percentage > 84 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='1079'
        y='34.5'
        width='50'
        height='158'
        fill={percentage > 89 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='1142'
        y='25.5'
        width='50'
        height='167'
        fill={percentage > 94 ? fillColor : '#FFFFFF'}
      />
      <rect
        x='1207'
        y='17.5'
        width='50'
        height='175'
        fill={percentage > 99 ? fillColor : '#FFFFFF'}
      />
    </svg>
  </div>
)

export default ProgressGraphic